var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickynote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.5 8.37V15.82C21.5 15.97 21.45 16.12 21.32 16.25C19.87 17.71 17.29 20.31 15.81 21.8C15.68 21.94 15.51 22 15.34 22H7.37C4.68 22 2.5 19.82 2.5 17.13V8.37C2.5 5.68 4.68 3.5 7.37 3.5H16.63C19.32 3.5 21.5 5.68 21.5 8.37Z",
    fill: "#688FB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29004 6.29C7.87004 6.29 7.54004 5.95 7.54004 5.54V2.75C7.54004 2.34 7.87004 2 8.29004 2C8.71004 2 9.04004 2.34 9.04004 2.75V5.53C9.04004 5.95 8.71004 6.29 8.29004 6.29Z",
    fill: "#F04837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 6.29C15.29 6.29 14.96 5.95 14.96 5.54V2.75C14.96 2.33 15.3 2 15.71 2C16.13 2 16.46 2.34 16.46 2.75V5.53C16.46 5.95 16.13 6.29 15.71 6.29Z",
    fill: "#F04837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7799 12.71H7.35986C6.93986 12.71 6.60986 12.37 6.60986 11.96C6.60986 11.55 6.94986 11.21 7.35986 11.21H14.7799C15.1999 11.21 15.5299 11.55 15.5299 11.96C15.5299 12.37 15.1999 12.71 14.7799 12.71Z",
    fill: "#F04837"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 16.42H7.35986C6.93986 16.42 6.60986 16.08 6.60986 15.67C6.60986 15.25 6.94986 14.92 7.35986 14.92H11.9999C12.4199 14.92 12.7499 15.26 12.7499 15.67C12.7499 16.08 12.4199 16.42 11.9999 16.42Z",
    fill: "#F04837"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4999 15.82C21.4999 15.97 21.4499 16.12 21.3199 16.25C19.8699 17.71 17.2899 20.31 15.8099 21.8C15.6799 21.94 15.5099 22 15.3399 22C15.0099 22 14.6899 21.74 14.6899 21.36V17.86C14.6899 16.4 15.9299 15.19 17.4499 15.19C18.3999 15.18 19.7199 15.18 20.8499 15.18C21.2399 15.18 21.4999 15.49 21.4999 15.82Z",
    fill: "#F04837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickynote);
export default __webpack_public_path__ + "static/media/stickynote.7898fd96cbbe9cc09f5cbe3649f18508.svg";
export { ForwardRef as ReactComponent };